import { generatePath, Link } from "react-router-dom"
import { Button, Tag } from "antd"

import { notify } from "@src/app/components/notify"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { paths } from "@src/app/paths"
import { PAYMENTS_PRICING_TYPES_OPTIONS } from "@src/pages/transactionsPayments/constants"
import { catchErrors, chargeApi } from "@src/shared/api"
import { ChargeResponse } from "@src/shared/api/generated"
import { TableExpandable } from "@src/shared/componemts/TableExpandable"
import { dateTimeFormat } from "@src/shared/date"
import { parsePricing, Pricing } from "@src/shared/parsePricing"
import css from "./index.module.css"

export const TransactionInListExpandable = ({
  charge,
  isLoading,
}: {
  charge: ChargeResponse
  isLoading: boolean
}) => {
  const {
    context,
    created_at,
    external_id,
    id,
    init_price,
    is_resolve_overpaid,
    is_resolve_underpaid,
    merchant_price,
    payments,
    pricing,
    pricing_type,
    project_id,
    status,
  } = charge

  const cryptoAmount = parsePricing(pricing as Pricing)

  const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
    network: cryptoAmount?.network,
    symbol: cryptoAmount?.symbol,
  })

  const merchPriceCurrency = GlobalCurrenciesCollection().getBySymbolNetwork({
    network: merchant_price?.network as any,
    symbol: merchant_price?.symbol as any,
  })

  const currencyFiat = init_price
    ? GlobalCurrenciesCollection().getBySymbolNetwork({
        network: init_price.network as string,
        symbol: init_price.symbol as string,
      })
    : undefined

  const shouldApproveButtonBeVisible =
    status === "unresolved" &&
    ((is_resolve_underpaid === false && context === "underpaid") ||
      (is_resolve_overpaid === false && context === "overpaid"))

  const resolveCharge = (id: string) =>
    chargeApi
      .resoleCharge(id)
      .then(() => notify.success("Charge resolved"))
      .catch(catchErrors)

  const pricingTypeItem = PAYMENTS_PRICING_TYPES_OPTIONS.find(
    (i) => i.value === (pricing_type as any),
  )

  const list: [string, any][] = [
    ["ID", id],
    ["Project ID", project_id],
    ["External ID", external_id],
    ["Pricing type", pricingTypeItem?.label],
    [
      "Status",
      <Tag color={status === "completed" ? "green" : "geekblue"}>{status}</Tag>,
    ],
    [
      "Amount(fiat)",
      init_price?.amount
        ? `${init_price.amount} ${currencyFiat?.symbol ?? init_price?.symbol}`
        : "Donation",
    ],
    [
      "Amount(crypto)",
      `${cryptoAmount?.amount_paid} ${currency?.symbol_alias ?? cryptoAmount?.symbol}`,
    ],
    [
      "Amount(Credited)",
      merchant_price
        ? `${merchant_price?.amount_paid} ${merchPriceCurrency?.symbol ?? merchant_price?.symbol}`
        : "-",
    ],
    ["Created at", dateTimeFormat(created_at as string)],
  ]

  return (
    <TableExpandable
      actions={
        <div className={css.buttonsWrapper}>
          {Boolean(payments?.length) && (
            <Link
              id="GENERATED_ID_TRANSACTIONINLISTEXPANDABLE_LINK_VOID_1"
              to={generatePath(paths.payments, { id: id! })}
            >
              <Button
                id="GENERATED_ID_TRANSACTIONINLISTEXPANDABLE_BUTTON_PAYMENTS_1"
                onClick={() => {}}
                size="large"
                type="primary"
              >
                Payments
              </Button>
            </Link>
          )}
          {shouldApproveButtonBeVisible && (
            <Button
              id="GENERATED_ID_TRANSACTIONINLISTEXPANDABLE_BUTTON_APPROVE_1"
              onClick={() => resolveCharge(id!)}
              size="large"
              type="default"
            >
              Approve
            </Button>
          )}
        </div>
      }
      isLoading={isLoading}
      list={list}
    />
  )
}
